import { render } from "./AddUser.vue?vue&type=template&id=40b391bc&scoped=true&ts=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"

import "./AddUser.vue?vue&type=style&index=0&id=40b391bc&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b391bc"]])

export default __exports__